export const UserActionTypes = {
  SET_CURRENT_USER_TOKEN: "SET_CURRENT_USER_TOKEN",
  SET_CURRENT_USER: "SET_CURRENT_USER",
};
